import { CircularProgress, Grid } from "@mui/material";
import { withErrorBoundary } from "hocs/withErrorBoundary";
import useGlobalContext from "hooks/globalData";
import { useStrictQuery } from "hooks/useStrictQuery";
import LearningObjectiveBox from "pages/SkusPage/SkuLearningObjectives/SkuLearningObjectiveBox";
import {
  ListRequestOfBaseFilter,
  ListResponseOfSkuMajorTopic,
  Skus,
} from "services/KnowfullyAdminClient";

const SkuLearningObjectivesList = ({
  skuId,
  sku,
}: {
  skuId: string;
  sku: Skus | undefined;
}) => {
  const { skuService } = useGlobalContext();

  const { data, isFetching } = useStrictQuery<ListResponseOfSkuMajorTopic>(
    ["skuLearningObjectives", skuId],
    () =>
      skuService.getSkuLearningObjectives(
        skuId,
        ListRequestOfBaseFilter.fromJS({
          sortField: "createdOn",
          sortDescending: true,
        })
      ),
    { enabled: !!skuId && !!sku }
  );

  const renderLearningObjectives = () =>
    data?.data?.map((skuLearningObjective, i) => (
      <LearningObjectiveBox
        key={skuLearningObjective.id}
        skuLearningObjective={skuLearningObjective}
        sku={sku!}
        showActions={false}
        index={i}
      />
    ));

  return (
    <>
      {isFetching ? (
        <CircularProgress style={{ float: "left" }} size={24} />
      ) : (
        <Grid container>{renderLearningObjectives()}</Grid>
      )}
    </>
  );
};

export default withErrorBoundary(SkuLearningObjectivesList);
